import dynamic from 'next/dynamic'
import { Grid, Typography } from '@mui/material'

// Types
import type { LogoProps } from '@/types/components/molecules/logo'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

// Fonts
import NexaFont from '@/styles/fonts/nexa'

// Components
const LogoIconAtom = dynamic(() => import('@/components/atoms/icons/logo'))

const LogoMolecule = (props: LogoProps) => {
	// Props
	const { lng, isMask } = props

	// Variables
	const { t } = useTranslation(lng)

	return (
		<Grid container alignItems="center">
			<Grid width={{ xs: 36, sm: 48, md: 48, lg: 72 }} height={{ xs: 36, sm: 48, md: 48, lg: 72 }}>
				<LogoIconAtom
					sx={{
						color: isMask ? 'background.default' : 'primary.main',
						fontSize: { xs: 36, sm: 48, md: 48, lg: 72 }
					}}
				/>
			</Grid>

			<Grid ml={{ xs: 1, md: 2, lg: 3 }}>
				<Typography
					variant="body1"
					fontFamily={NexaFont.style.fontFamily}
					fontSize={{ xs: 18, md: 22, lg: 25 }}
					fontWeight={700}
					color={isMask ? 'background.default' : 'common.white'}
				>
					{t('common:app.name')}
				</Typography>

				<Typography variant="body1" fontFamily={NexaFont.style.fontFamily} fontSize={{ xs: 12, md: 16, lg: 18 }} fontWeight={700} color="#9a9fad">
					{t('common:title.logoDescription')}
				</Typography>
			</Grid>
		</Grid>
	)
}

export default LogoMolecule
